import React, { useState } from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClose} from "@fortawesome/free-solid-svg-icons";

const TagsInput = ({ name, title, value = [], onChange }) => {
    const [tags, setTags] = useState(value);

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            const newTag = e.target.value.trim();
            if (newTag && !tags.includes(newTag)) {
                const updatedTags = [...tags, newTag];
                setTags(updatedTags);
                onChange({ target: { name, value: updatedTags } }); // Mimic input event
                e.target.value = ""; // Clear input
            }
        }
    };

    const removeTag = (index) => {
        const updatedTags = tags.filter((_, i) => i !== index);
        setTags(updatedTags);
        onChange({ target: { name, value: updatedTags } });
    };

    return (
        <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">{title}</label>
            <div className="flex flex-wrap items-center gap-2 border border-gray-300 rounded-md p-2 rtl">
                {tags.map((tag, index) => (
                    <div key={index} className="flex items-center bg-blue-500 text-white px-2 py-2 rounded-full space-x-2">
                        <span className='relative'>{tag}</span>
                        <button
                            className="mr-3 p-1  rounded-full bg-white text-black flex relative hover:text-red-500"
                            onClick={() => removeTag(index)}
                        >
                            <FontAwesomeIcon icon={faClose} />
                        </button>
                    </div>
                ))}
                <input
                    type="text"
                    className="border-none focus:outline-none p-2 flex-1"
                    placeholder="افزودن تگ..."
                    onKeyDown={handleKeyDown}
                />
            </div>
        </div>
    );
};

export default TagsInput;
